import script from "./storagePayReview.vue?vue&type=script&setup=true&lang=js"
export * from "./storagePayReview.vue?vue&type=script&setup=true&lang=js"

import "./storagePayReview.vue?vue&type=style&index=0&id=525f4550&lang=less"

const __exports__ = script;

export default __exports__